import { render, staticRenderFns } from "./sphf.vue?vue&type=template&id=20fc6c64"
import script from "./sphf.vue?vue&type=script&lang=js"
export * from "./sphf.vue?vue&type=script&lang=js"
import style0 from "./sphf.vue?vue&type=style&index=0&id=20fc6c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports